export const Footer = () => (
  <footer className="border-t border-border/70">
    <div className="mx-auto flex max-w-[1180px] flex-col items-center justify-between gap-3 px-5 py-7 text-[13px] text-muted-foreground sm:flex-row sm:px-8">
      <span>© 12steps</span>
      <nav className="flex items-center gap-3">
        <a href="#privacy" className="transition-colors hover:text-foreground">Privacy</a>
        <span className="text-border-strong">·</span>
        <a href="#terms" className="transition-colors hover:text-foreground">Terms</a>
        <span className="text-border-strong">·</span>
        <a href="#support" className="transition-colors hover:text-foreground">Support</a>
      </nav>
    </div>
  </footer>
);
